import React, { useRef, useState } from "react";
import { AddFlex, CustomText, SecondaryActionButton } from "./reusableStyles";
import { handleImageUpload } from "../utils/utils";
import { enqueueSnackbar } from "notistack";

function FileUpload({ handleGetFileData }) {
  const [file, setFile] = useState(null);

  const inputRef = useRef();
  const onFileChange = async (e) => {
    const file = e.target.files[0];
    setFile(file);
    handleGetFileData(file);
  };
  return (
    <>
      <AddFlex flexDirection="column">
        <CustomText>{file?.name}</CustomText>
        <SecondaryActionButton
          onClick={() => {
            inputRef.current.click();
          }}
          style={{ width: "max-content" }}
        >
          Add File
        </SecondaryActionButton>
      </AddFlex>
      <input
        type="file"
        ref={inputRef}
        style={{ display: "none" }}
        onChange={onFileChange}
      />
    </>
  );
}

export default FileUpload;
